export default __webpack_public_path__ + "media/zurb/img/legacy/icons/feeder/plunk-211c1866b6de3fbd86307c7f29053345.png";